module.exports = __webpack_public_path__ + "img/TrustServiceCategor2.373d7b7d.png";